// extracted by mini-css-extract-plugin
module.exports = {"black":"#000","grey":"#999","circularBold":"\"poppins-bold\"","primaryColor":"var(--primary-color)","darkGreyColor":"var(--dark-grey-color)","success":"#6fd361"};